/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'DAILY_LIMITS_ON_OVERTIME_HOURS_WORKED_',
              'WEEKLY_LIMITS_ON_OVERTIME_HOURS_WORKED',
              'MONTHLY_LIMITS_ON_OVERTIME_HOURS_WORKED',
              'YEARLY_LIMITS_ON_OVERTIME_HOURS_WORKED',
              'OTHER',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    which_legal_overtime_limits_are_not_being_complied_w_select_all: valueSchema,
  },
}
